import { render, staticRenderFns } from "./SearchTab.vue?vue&type=template&id=42341d0a&scoped=true&"
import script from "./SearchTab.vue?vue&type=script&lang=js&"
export * from "./SearchTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42341d0a",
  null
  
)

export default component.exports